import React from 'react';
import PropTypes from 'prop-types';

import ClearIcon from '@material-ui/icons/Clear';

import { TextFilter, TextTags, getTextApiParam } from './Text';


export const FullnameValue = React.memo((props) => {
  const {
    column,
    data
  } = props;
  
  
  return [data.lastname, data.firstname, data.patronymic].filter(Boolean).join(' ').trim() || '-';
});

export const FullnameFilter = TextFilter;

export const FullnameTags = TextTags;

export const getFullnameApiParam = getTextApiParam;

export const getFullnameExportValue = async (props, column, data) => {
  return [data.lastname, data.firstname, data.patronymic].filter(Boolean).join(' ').trim() || '-';
};
